export enum ExternalUserDeletionBlockerType {
    InternalAssessment = 1,
}

export const externalUserBlockerTranslationKeys: Record<ExternalUserDeletionBlockerType, string> = {
    [ExternalUserDeletionBlockerType.InternalAssessment]: "internalAssessments",
};
